import { Page } from '@/core/architecture'

import { ArtistMembershipPaymentEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistMembershipPaymentEdit Page
 * Implemented as a practical sample.
 */
export const ArtistMembershipPaymentEdit: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistMembershipPaymentEditTemplate state={state} {...actions} />
}
